import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function ProtectedRoute({
  children,
  adminOnly    = false,
  editorOnly   = false,
  userOnly     = false,
  dashboardOnly = false,   // admin_editor, admin_viewer, aboutu
}) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div className="spinner" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  // Feedback page: only regular users
  if (userOnly && user.role !== 'user') {
    if (user.role === 'aboutu') return <Navigate to="/admin/dashboard" replace />;
    return <Navigate to="/admin/dashboard" replace />;
  }

  // Dashboard page: admin_editor, admin_viewer, aboutu
  if (dashboardOnly &&
      user.role !== 'admin_editor' &&
      user.role !== 'admin_viewer' &&
      user.role !== 'aboutu') {
    return <Navigate to="/unauthorized" replace />;
  }

  // Admin-only pages: admin_editor, admin_viewer (NOT aboutu)
  if (adminOnly &&
      user.role !== 'admin_editor' &&
      user.role !== 'admin_viewer') {
    if (user.role === 'aboutu') return <Navigate to="/admin/dashboard" replace />;
    return <Navigate to="/unauthorized" replace />;
  }

  // Editor-only pages
  if (editorOnly && user.role !== 'admin_editor') {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}
